<template>
  <div class="main">
    <div class="view-container">
      <div class="view-box" style="margin-top: 100px">
        <div>
          <!-- <excel :data="list" :fields="json_fields" :title="'【采购平台】业务员绩效结算申请表'"/> -->
          <div class="sett-title">
            <div>【采购平台】业务员绩效结算申请表</div>

            <!-- <download-excel
              class="btn btn-default"
              :data="list"
              :fields="json_fields"
              worksheet="Sheet 1"
              type="csv`"
              name="【采购平台】项目员绩效结算申请表.csv`"
              ><span
                ><img
                  src="../../assets/image/excel.png"
                  alt=""
                  style="width: 20px; height: 20px; cursor: pointer"
                  title="导出Excel"
              /></span>
            </download-excel> -->
          </div>
        </div>
        <div class="printTable">
          <div class="printTr">
            <div class="printTd" v-for="(item, index) in clos" :key="index">
              {{ item.label }}
            </div>
          </div>
          <div class="printTr" v-for="(item, index) in list" :key="index">
            <div class="printTd" style="width: 150px">
              {{ item.projectcode }}
            </div>
            <div class="printTd" style="width: 200px">
              {{ item.projectname }}
            </div>
            <div class="printTd" style="width: 200px">{{ item.Pcomname }}</div>
            <div class="printTd" style="width: 150px">
              {{ item.projectlimitamt | qfwVal }}
            </div>
            <div class="printTd" style="width: 100px">
              {{ item.ptcusername }}
            </div>
            <div class="printTd" style="width: 100px">
              {{ item.confirmfeeamt | qfwVal }}
            </div>
            <div class="printTd" style="width: 200px">
              {{ item.psufewreceivetime }}
            </div>
            <div class="printTd" style="width: 100px"></div>
            <div class="printTd" style="width: 100px"></div>
            <div class="printTd" style="width: 100px"></div>
          </div>
        </div>
        <div class="fooder">
          <div class="f-box">
            <div class="item">
              <div class="laber">结算申请人：</div>
              <div class="values"></div>
            </div>
            <div class="item">
              <div class="laber">日期：</div>
              <div class="values"></div>
            </div>
          </div>
          <div class="f-box">
            <div class="item">
              <div class="laber">审批人：</div>
              <div class="values"></div>
            </div>
            <div class="item">
              <div class="laber">日期：</div>
              <div class="values"></div>
            </div>
          </div>
          <div class="f-box">
            <div class="item">
              <div class="laber">财务确认：</div>
              <div class="values"></div>
            </div>
            <div class="item">
              <div class="laber">日期：</div>
              <div class="values"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import request from "@/utils/request";
import utils from "../../assets/js/utils";
import downloadExcel from "vue-json-excel";
import excel from "./excel.vue";
export default {
  name: "settlemanetPrint",
  computed: {},
  data() {
    return {
      clos: [
        { prop: "projectcode", label: "项目编号" },
        { prop: "projectname", label: "项目名称" },
        { prop: "Pcomname", label: "采购人" },
        { prop: "projectlimitamt", label: "预算额（元）" },
        { prop: "ptcusername", label: "业务员" },
        { prop: "confirmfeeamt", label: "服务费（元）" },
        { prop: "psufewreceivetime", label: "收取日" },
        { prop: "psusalerewardmoney", label: "结算金额" },
        { prop: "psusalerewardtime", label: "结算日" },
        { prop: "psusalerewarder", label: "结算人" },
      ],
      list: [],
      query: {
        isMyself: 1,
        salerewardflg: 0,
        cosid: this.$store.getters.loginUser.cosid,
        userid: this.$store.getters.loginUser.userid,
        comid: this.$store.getters.loginUser.comid,
      },
      // json_fields: {
      //   "项目编号": "projectcode",
      //   "项目名称": "projectname",
      //   "采购人": "Pcomname",
      //   "预算额（元）": "projectlimitamt",
      //   "项目员": "ptcusername",
      //   "服务费（元）": "confirmfeeamt",
      //   "收取日": "ptcusername",
      //   "结算金额": "psusalerewardmoney",
      //   "结算日": "psusalerewardtime",
      //   "结算人": "psusalerewarder",
      // },
      json_fields: [
        {title: "项目编号",dataIndex: "projectcode",width: 350},
        {title: "项目名称",dataIndex: "projectname",width: 350},
        {title: "采购人",dataIndex: "Pcomname",width: 350},
        {title: "预算额（元）",dataIndex: "projectlimitamt",width: 350},
        {title: "项目员",dataIndex: "ptcusername",width: 350},
        {title: "服务费（元）",dataIndex: "confirmfeeamt",width: 350},
        {title: "收取日",dataIndex: "psufewreceivetime",width: 350},
        {title: "结算金额",dataIndex: "psusalerewardmoney",width: 350},
        {title: "结算日",dataIndex: "psusalerewardtime",width: 350},
        {title: "结算人",dataIndex: "psusalerewarder",width: 350},
      ],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },
  async created() {
    await this.getPerformance();
  },
  filters: {
    qfwVal(value) {
      return utils.comdify(value);
    },
  },
  activated() {},
  components: { downloadExcel, excel },
  mounted() {},
  methods: {
    async getPerformance() {
      this.query.isMyself = this.$route.query.isMyself;
      this.query.salerewardflg = this.$route.query.salerewardflg;
      this.query.startTime = this.$route.query.startTime;
      this.query.endtTime_c = this.$route.query.endtTime_c;

      let res = await request({
        url: "/basic/statisticalAnalysis/getPerformance",
        method: "get",
        params: this.query,
      });
      res.data.map((e) => {
        if (
          isNaN(e.psufewreceivetime) &&
          !isNaN(Date.parse(e.psufewreceivetime))
        ) {
          e.psufewreceivetime = utils.formatterDate(
            e.psufewreceivetime,
            "yyyy-MM-dd"
          );
          return e;
        } else {
          return e;
        }
      });
      this.list = res.data;
    },
  },
};
</script>
<style lang="scss" scoped>
.sett-title {
  display: flex;
  justify-content: center;
  text-align: center;
  font-size: 23px;
  font-weight: bold;
  margin: 10px 0;
}
.printTable {
  display: table;
  border: 1px solid #000000;
  text-align: center;
  margin: 0 auto;
  .printTr {
    display: table-row;
    border: 1px solid #000000;
    .printTd {
      display: table-cell;
      border-bottom: 1px solid #000000;
      border-right: 1px solid #000000;
      // padding: 5px;
      &:last-child {
        border-right: none;
      }
    }
    &:last-child .printTd {
      border-bottom: none;
    }
  }
}
.fooder {
  display: flex;
  justify-content: space-around;
  margin: 20px 0;
  .item {
    margin: 10px 0;
  }
}
</style>
